// ReSharper disable once UnusedParameter
window.ajaxHelper = (function (window, $, undefined) {
	'use strict';
	const requests = {};
	const queuedData = {};

	// ReSharper disable once InconsistentNaming
	function _onlyOneWithDiscard(url, data, onSuccess) {
		requests[url] = $.post(url, data, function () {
			if (typeof onSuccess === 'function' && !queuedData[url]) {
				// nur dann den onSuccess-Callback ausführen, wenn nicht noch ein weiterer Request gemcht werden muss
				onSuccess.apply(this, arguments);
			}
		}).always(function () {
			if (queuedData[url]) {
				requests[url] = _onlyOneWithDiscard(url, queuedData[url].data, queuedData[url].onSuccess);
				queuedData[url] = null;
			} else {
				requests[url] = null;
			}
		});
	}

	/**
	 * Führt nur einen AJAX-Request gleichzeitig (pro URL) auf.
	 * Wenn vor dem Server-Response weitere Aufrufe für die gleiche URL gemacht werden, werden die Daten des letzten zwischengespeichert und nach dem Server-Response wird direkt wieder ein AJAX-Request gestartet.
	 * Die onSuccess-Funktion wird nur aufgerufen, wenn es keine zwischengespeicherten Daten gibt.
	 *
	 * @param {string} url Url an den der AJAX-Request gesendet werden soll
	 * @param {object} data Daten für den AJAX-Request
	 * @param {function} onSuccess (optional) Callback, wenn der AJAX-Request erfolgreich ist
	 * @returns {void}
	 */
	function onlyOneWithDiscard(url, data, onSuccess) {
		if (!requests[url]) {
			_onlyOneWithDiscard(url, data, onSuccess);
		} else {
			queuedData[url] = { data: data, onSuccess: onSuccess };
		}
	}

	// ReSharper disable once InconsistentNaming
	const jqXHRs = {};
	/**
	 * Führt nur einen AJAX-Request gleichzeitig (pro URL) auf.
	 * Wenn vor dem Server-Response weitere Aufrufe für die gleiche URL gemacht werden, wird der aktuelle Request abgebrochen.
	 *
	 * @param {string} url Url an den der AJAX-Request gesendet werden soll
	 * @param {object} data Daten für den AJAX-Request
	 * @param {function} onSuccess (optional) Callback, wenn der AJAX-Request erfolgreich ist
	 * @returns {void}
	 */
	function onlyOneWithAbort(url, data, onSuccess) {
		if (jqXHRs[url]) {
			try {
				jqXHRs[url].abort();
			} catch (e) {
				console.error(e); // eslint-disable-line no-console
			}
			jqXHRs[url] = null;
		}
		$.ajax({
			url: url,
			type: 'POST',
			data: data,
			beforeSend: function (jqXHR) {
				jqXHRs[url] = jqXHR;
			},
			success: onSuccess,
			complete: function (jqXHR) {
				if (jqXHRs[url] === jqXHR) {
					jqXHRs[url] = null;
				}
			},
		});
	}

	/**
	 *
	 * @param {string} url Url an den der AJAX-Request gesendet werden soll
	 * @param {string} data Daten für den AJAX-Request
	 * @returns {jqXHR} jqXHR-Objekt, das keine global registrierten Events verwendet
	 */
	function postOhneAlert(url, data) {
		return $.ajax({
			cache: false,
			method: 'post',
			global: false, // u.A.: bei einem Fehler nicht den Standard-Alert anzeigen
			url: url,
			data: data,
		});
	}

	return {
		nurEinRequestUndLetzterInQueue: onlyOneWithDiscard,
		nurEinRequest: onlyOneWithAbort,
		postOhneAlert: postOhneAlert,
	};
})(window, jQuery);
